module.exports = "https://cdn.redage.net/src/views/player/oressale/assets/images/ore_coal.png";